
import Login from "@/views/Login-view";
import Signup from "@/views/Signup-view";
import CreatePassword from "@/views/Create-password-view";

import ShoppingDetailView from "@/views/Shopping-detail-view";

import Home from '@/views/Home-view'
import Historic from "@/views/Historic-view";
import ShopAddress from "@/views/Shop-address-view";
import Notification from "@/views/Notification-view";
import Profile from "@/views/Profile-view";
import RewardDetail from "@/views/Reward-detail-view";
import Prize from "@/views/Prize-view";
import PrizeDetail from "@/app/components/prize-detail/prize-detail";
import OfferNewspaperView from "@/views/OfferNewspaper-view";
import SweepstakesView from "@/views/Sweepstakes-view";
import SweepstakesDetailView from "@/views/Sweepstakes-detail-view"
import ReferFriendsView from "@/views/ReferFriends-view"; 

import PhoneRegistrationFound from "@/views/PhoneRegistrationFound-view";
import Telephone from "@/views/Telephone-view";
import Rating from "@/views/Rating-view";
import Offers from "@/views/Offers-view";
import OfferDetail from "@/views/Offer-detail-view";

import pointsProgram from "@/views/Points-Program-view";

export const routes = [
  //Login
  { path: '/login', component: Login, meta: { requiresAuth: false } },

  //Processo de cadastro
  { path: '/cadastro', component: Signup, meta: { requiresAuth: false } },
  { path: '/acessos', component: Telephone, meta: { requiresAuth: false } },
  { path: '/confirmacaoTelefone', component: PhoneRegistrationFound, meta: { requiresAuth: false } },
  { path: '/senha', component: CreatePassword, meta: { requiresAuth: false }, props: (route) => ({ query: route.query.uniqueId }) },

  //Detalhe de compras
  { path: '/compras', component: ShoppingDetailView, meta: { requiresAuth: false }, props: (route) => ({ query: route.query.uniqueId }) },

  { path: '/', redirect: '/inicio' },
  { path: '*', redirect: '/inicio' },
  { path: '/inicio', component: Home, meta: { requiresAuth: false } },
  { path: '/detalhe/:id', component: RewardDetail, meta: { requiresAuth: false } },
  { path: '/loja', component: ShopAddress, meta: { requiresAuth: false } },
  { path: '/avaliacao', component: Rating, meta: { requiresAuth: false }, props: (route) => ({ query: route.query.id, query: route.query.contactId }) },
  { path: '/jornal', component: OfferNewspaperView, meta: { requiresAuth: false }  },

  //Precisa de autenticação
  { path: '/detalheOferta', component: OfferDetail, meta: { requiresAuth: true }, props: (route) => ({ query: route.query.participantId }) },
  { path: '/historico', component: Historic, meta: { requiresAuth: true } },
  { path: '/notificacoes', component: Notification, meta: { requiresAuth: true } },
  { path: '/perfil', component: Profile, meta: { requiresAuth: true }, props: (route) => ({ query: route.query.sessionId }) },
  { path: '/premios', component: Prize, meta: { requiresAuth: true } },
  { path: '/detalhePremio', component: PrizeDetail, meta: { requiresAuth: true }, props: (route) => ({ query: route.query.premioId }) },
  { path: '/ofertas', component: Offers, meta: { requiresAuth: true } },
  { path: '/pontos', component: pointsProgram, meta: { requiresAuth: true } },
  { path: '/sorteios', component: SweepstakesView, meta: { requiresAuth: true }, props: (route) => ({ query: route.query.sweepstakesId }) },
  { path: '/detalheSorteio', component: SweepstakesDetailView, meta: { requiresAuth: true },  },
  { path: '/indiqueAmigos', component: ReferFriendsView, meta: { requiresAuth: true } }
]
